import { useCallback, useState } from 'react';
import { useChatbotContext } from '../../../hooks/ChatbotContext';
import { sanitizeMessageText } from '../../../utils/sanitizeMessageText';

/**
 * Custom hook for message-related actions
 * @param {Object} params - Hook parameters
 * @param {Object} params.message - The message object
 * @returns {Object} Message action handlers and states
 */
export function useMessageActions({ message }) {
  // Get the audio manager from context
  const { audioManager } = useChatbotContext();

  // Copy functionality
  const [showCopySuccess, setShowCopySuccess] = useState(false);

  const handleCopyMessage = useCallback(() => {
    const cleanText = sanitizeMessageText(message.text);
    navigator.clipboard.writeText(cleanText).then(() => {
      setShowCopySuccess(true);
      setTimeout(() => setShowCopySuccess(false), 1500);
    });
  }, [message.text]);

  // Audio functionality - simplified with audioManager
  const handlePlayAudio = useCallback(() => {
    audioManager.playAudio(message.id, message.text);
  }, [audioManager, message.id, message.text]);

  return {
    // Copy actions
    handleCopyMessage,
    showCopySuccess,

    // Audio actions
    handlePlayAudio,
    isPlayingAudio: audioManager.isPlaying(message.id),
    isLoadingAudio: audioManager.isLoading(message.id),
    audioError: audioManager.error,
  };
}
